import Ikom from "../../apis/Ikom";

export default {
    namespaced: true,
    state: {
        loading: false,
        transactions: [],
        years: [2019, 2020, 2021, 2022],
        series: [
            {
                name: 'series-1',
                data: [666, 40, 45, 50, 49, 60, 70, 91]
            }
        ],
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]

    },
    getters: {
        get_chart_loading(state) {
            return state.loading
        },
        get_series(state) {
            return state.series
        },
        get_categories(state) {
            return state.categories
        },
        get_years(state) {
            return state.years
        }
    },
    mutations: {
        set_chart_loading(state, payload) {
            state.loading = payload
        },
        set_years(state, payload) {
            state.years = payload
        },
        set_series(state, payload) {
            state.series = payload
        },
        set_categories(state, payload) {
            state.categories = payload
        }
    },
    actions: {}
}